import TextRich from 'core/modules/atoms/TextRich/TextRich';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LessonRecommendationItem from './LessonRecommendationItem';
import './UnitRecommendationsCard.scss';

/**
 * UnitRecommendationsCard - Displays unit with lessons that need attention
 */
const UnitRecommendationsCard = ({ unit }) => {
  const { t } = useTranslation(['chatbot']);

  return (
    <div className="unit-recommendations-card">
      <div className="unit-recommendations-card__indicator" />
      <div className="unit-recommendations-card__content">
        <div className="unit-recommendations-card__header">
          <h3 className="unit-recommendations-card__title">
            <TextRich text={unit.title} />
          </h3>
        </div>
        <div className="unit-recommendations-card__lessons">
          {unit.lessons && unit.lessons.length > 0 ? (
            unit.lessons.sort((a, b) => a.order - b.order).map((lesson) => <LessonRecommendationItem key={lesson.lessonId} lesson={lesson} />)
          ) : (
            <p className="unit-recommendations-card__no-recommendations">{t('analytics_no_recommendations')}</p>
          )}
        </div>
      </div>
    </div>
  );
};

UnitRecommendationsCard.propTypes = {
  unit: PropTypes.shape({
    unitId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    order: PropTypes.number,
    lessons: PropTypes.arrayOf(
      PropTypes.shape({
        lessonId: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        order: PropTypes.number,
        alertReasons: PropTypes.arrayOf(PropTypes.string),
      })
    ),
  }).isRequired,
};

export default UnitRecommendationsCard;
